import React, { PureComponent } from 'react'
import styled from 'styled-components/native'
import { View, Platform } from 'react-native'
import { Text, Rect, G, TSpan } from 'react-native-svg'
import { StackedBarChart as _StackedBarChart } from 'react-native-svg-charts'

import { thousandSeparator } from '../../../../lib/formatters'
import theme from '../../../../styles/theme'

const Container = styled(View)`
  flex: 1;
  height: ${props => props.height}px;
  width: ${props => props.width}px;
`

const StackedBarChart = styled(_StackedBarChart)`
  flex: 1;
  height: ${props => props.height}px;
  width: ${props => props.width}px;
  position: absolute;
  left: 0;
  top: 0;
`

const BandWidthFactor = 0.3

const EXISTING_FUNDING_COLOUR = '#93d8fc'

const YAXIS_TICK_SPACING = 20000

const LEFT_INSET = 110
const RIGHT_INSET = 40

const formatValue = (val) => {
  if (val === 0) {
    return '0'
  }
  if (val < 0) {
    return `(${thousandSeparator(val * -1)})`
  }
  return thousandSeparator(val)
}
export default class AssetsProfileChart extends PureComponent {
  render () {
    let {
      height = 200,
      width,
      decisions,
      fundingProfile
    } = this.props

    const depositsYr1 = parseInt((fundingProfile.depositsYr1 * (1 + (decisions.depositGrowthChangePercentage / 10000))).toFixed(0))
    const depositsYr2 = parseInt((fundingProfile.depositsYr2 * (1 + (decisions.depositGrowthChangePercentage / 10000))).toFixed(0))
    const depositsYr3 = parseInt((fundingProfile.depositsYr3 * (1 + (decisions.depositGrowthChangePercentage / 10000))).toFixed(0))
    const depositsYr4 = parseInt((fundingProfile.depositsYr4 * (1 + (decisions.depositGrowthChangePercentage / 10000))).toFixed(0))
    const depositsYr5 = parseInt((fundingProfile.depositsYr5 * (1 + (decisions.depositGrowthChangePercentage / 10000))).toFixed(0))

    const fundingData = [{
      index: 1,
      label: '1 YEAR',
      newFunding: decisions.wsf1,
      deposits: depositsYr1,
      existingFunding: fundingProfile.wsfYr1,
      total: decisions.wsf1 + depositsYr1 + fundingProfile.wsfYr1
    }, {
      index: 2,
      label: '2 YEAR',
      newFunding: decisions.wsf2,
      deposits: depositsYr2,
      existingFunding: fundingProfile.wsfYr2,
      total: decisions.wsf2 + depositsYr2 + fundingProfile.wsfYr2
    }, {
      index: 3,
      label: '3 YEAR',
      newFunding: decisions.wsf3,
      deposits: depositsYr3,
      existingFunding: fundingProfile.wsfYr3,
      total: decisions.wsf3 + depositsYr3 + fundingProfile.wsfYr3
    }, {
      index: 4,
      label: '4 YEAR',
      newFunding: decisions.wsf4,
      deposits: depositsYr4,
      existingFunding: fundingProfile.wsfYr4,
      total: decisions.wsf4 + depositsYr4 + fundingProfile.wsfYr4
    }, {
      index: 5,
      label: '5 YEAR',
      newFunding: decisions.wsf5,
      deposits: depositsYr5,
      existingFunding: fundingProfile.wsfYr5,
      total: decisions.wsf5 + depositsYr5 + fundingProfile.wsfYr5
    }]

    const assetsData = [{
      index: 1,
      label: '1 YEAR',
      assets: -1 * parseInt((fundingProfile.assetsYr1 * (1 + (decisions.fixedAssetsGrowth / 10000))).toFixed(0))
    }, {
      index: 2,
      label: '2 YEAR',
      assets: -1 * parseInt((fundingProfile.assetsYr2 * (1 + (decisions.fixedAssetsGrowth / 10000))).toFixed(0))
    }, {
      index: 3,
      label: '3 YEAR',
      assets: -1 * parseInt((fundingProfile.assetsYr3 * (1 + (decisions.fixedAssetsGrowth / 10000))).toFixed(0))
    }, {
      index: 4,
      label: '4 YEAR',
      assets: -1 * parseInt((fundingProfile.assetsYr4 * (1 + (decisions.fixedAssetsGrowth / 10000))).toFixed(0))
    }, {
      index: 5,
      label: '5 YEAR',
      assets: -1 * parseInt((fundingProfile.assetsYr5 * (1 + (decisions.fixedAssetsGrowth / 10000))).toFixed(0))
    }]

    width = width || height

    const actualMaxValue = Math.max(...fundingData.map(d => d.total))
    const maxValue = Math.ceil(Math.abs(actualMaxValue) / YAXIS_TICK_SPACING) * YAXIS_TICK_SPACING

    const actualMinValue = Math.max(...assetsData.map(d => d.assets * -1))
    const minValue = -1 * Math.ceil(Math.abs(actualMinValue) / YAXIS_TICK_SPACING) * YAXIS_TICK_SPACING

    const Labels = ({ x, y, data, width }) => {
      return data.reduce((result, data) => {
        if (data.deposits) {
          result.push(
            <Text
              key={`deposit${data.index}`}
              x={x(data.index - 1) + ((width - LEFT_INSET - RIGHT_INSET) / assetsData.length * (1 - BandWidthFactor)) / 2}
              // y={ y(cashAsPercentageOfTotalAssets < cashThreshold / 2 ? cash + (1 * yOffset) : cash / 2 ) }
              y={y(data.deposits / 2)}
              fontSize={14}
              fontFamily={Platform.select({ web: 'ubuntu-medium' })}
              fill='black'
              alignmentBaseline='middle'
              textAnchor='middle'
            >
              <TSpan>{thousandSeparator(data.deposits)}</TSpan>
            </Text>
          )
        }
        if (data.newFunding) {
          result.push(
            <Text
              key={`newFunding${data.index}`}
              x={x(data.index - 1) + ((width - LEFT_INSET - RIGHT_INSET) / assetsData.length * (1 - BandWidthFactor)) / 2}
              y={y(data.deposits + data.existingFunding + (data.newFunding / 2))}
              fontSize={14}
              fontFamily={Platform.select({ web: 'ubuntu-medium' })}
              fill='black'
              alignmentBaseline='middle'
              textAnchor='middle'
            >
              <TSpan>{thousandSeparator(data.newFunding)}</TSpan>
            </Text>
          )
        }
        if (data.total) {
          result.push(
            <Text
              key={`totalFunding${data.index}`}
              x={x(data.index - 1) + ((width - LEFT_INSET - RIGHT_INSET) / assetsData.length * (1 - BandWidthFactor)) / 2}
              y={y(data.deposits + data.existingFunding + data.newFunding + 4000)}
              fontSize={14}
              fontFamily={Platform.select({ web: 'ubuntu-medium' })}
              fill='black'
              alignmentBaseline='middle'
              textAnchor='middle'
            >
              <TSpan>{thousandSeparator(data.total)}</TSpan>
            </Text>
          )
        }
        return result
      }, [])
    }

    const YAxis = ({ x, y, data, width }) => {
      const items = []
      for (let value = minValue; value <= maxValue; value += YAXIS_TICK_SPACING) {
        items.push(
          <G
            key={value}
            style={{ zIndex: 0 }}
          >
            <Rect
              x={x(-LEFT_INSET)}
              y={y(value)}
              width={width - x(0) + LEFT_INSET}
              height={1}
              fill={value === 0 ? theme.colours.darkgrey : '#eeeeee'}
            />
            <Text
              x={x(0) - 35}
              y={y(value + 4000)}
              fontFamily={Platform.select({ web: 'ubuntu-bold' })} // TODO fontFamily fix
              fontSize={14}
              fontWeight='bold'
              alignmentBaseline='middle'
              textAnchor='end'
              fill='#888888'
            >
              {value === 0 ? '-' : formatValue(value)}
            </Text>
          </G>
        )
      }
      return items
    }
    const heightThing = 0
    return (
      <Container height={height} width={width}>
        <StackedBarChart
          width={width}
          height={height - heightThing}
          style={{ height: height - heightThing, width }}
          keys={['deposits', 'existingFunding', 'newFunding']}
          colors={[theme.colours.aqua, EXISTING_FUNDING_COLOUR, theme.colours.blue]}
          data={fundingData}
          // spacingOuter={0.2}
          spacingInner={BandWidthFactor}
          gridMin={minValue}
          gridMax={maxValue}
          contentInset={{ left: LEFT_INSET, top: 30, bottom: 20, right: RIGHT_INSET }}
        >
          <Labels />
          <YAxis belowChart />
        </StackedBarChart>
        <StackedBarChart
          width={width}
          height={height - heightThing}
          style={{ height: height - heightThing, width }}
          keys={['assets']}
          colors={[theme.colours.orange]}
          data={assetsData}
          spacingInner={BandWidthFactor}
          gridMin={minValue}
          gridMax={maxValue}
          contentInset={{ left: LEFT_INSET, top: 30, bottom: 20, right: RIGHT_INSET }}
        />
      </Container>
    )
  }
}
